import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useOrganizations from 'src/dataHooks/useOrganizations';
import PageSpin from 'src/components/PageSpin';

// Функция загрузки организаций мемоизированная, а данные меняются. Чтобы не беспокоить
// консумеров функции, когда меняются данные, используем два разных контекста.
export const ReloadOrganizationsContext = React.createContext<any>(() => {});
export const OrganizationsContext = React.createContext<any>(null);

type Props = {
  children: React.ReactElement<any, any> | null;
};

const OrganizationContextProvider: React.FC<Props> = ({ children }) => {
  const params = useParams();

  const { organizations, fetchOrganizations } = useOrganizations();

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  const currentOrganization = useMemo(() => {
    return params.organizationUeid
      ? organizations?.find(
          ({ organizationUeid }: { organizationUeid: any }) =>
            organizationUeid === params.organizationUeid
        )
      : null;
  }, [organizations, params.organizationUeid]);

  const organizationsContextValue = useMemo(() => ({ organizations, currentOrganization }), [
    organizations,
    currentOrganization,
  ]);

  if (!organizations) {
    return <PageSpin />;
  }

  // "Same element reference" оптимизация. https://youtu.be/K19dWjcI1Jk
  return (
    <ReloadOrganizationsContext.Provider value={fetchOrganizations}>
      <OrganizationsContext.Provider value={organizationsContextValue}>
        {children}
      </OrganizationsContext.Provider>
    </ReloadOrganizationsContext.Provider>
  );
};

export default OrganizationContextProvider;
